export default {
  en: "Englisch",
  fr: "Französisch",
  es: "Spanisch",
  de: "Deutsch",
  it: "Italienisch",
  pt: "Portugiesisch",
  ru: "Russisch",
  zh: "Chinesisch",
  ja: "Japanisch",
  ko: "Koreanisch",
  ar: "Arabisch",
  hi: "Hindi",
  tr: "Türkisch",
  nl: "Niederländisch",
  pl: "Polnisch",
  sv: "Schwedisch",
  da: "Dänisch",
  fi: "Finnisch",
  no: "Norwegisch",
  cs: "Tschechisch",
  hu: "Ungarisch",
  ro: "Rumänisch",
  bg: "Bulgarisch",
  el: "Griechisch",
  he: "Hebräisch",
  th: "Thailändisch",
  vi: "Vietnamesisch",
  id: "Indonesisch",
  ms: "Malaiisch",
  fa: "Persisch"
};

